(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-steps"] && !Shopify.designMode) return;
  try {
    
  class AbrisStepsFlow extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-step]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.onViewportChange = () => this.scheduleUpdate();
      this.onMotionChange = () => this.scheduleUpdate();

      this.classList.add('is-enhanced');
      window.addEventListener('scroll', this.onViewportChange, { passive: true, capture: true });
      window.addEventListener('resize', this.onViewportChange, { passive: true });
      this.motionQuery.addEventListener?.('change', this.onMotionChange);
      this.resizeObserver = new ResizeObserver(this.onViewportChange);
      this.resizeObserver.observe(this);
      this.steps.forEach((step) => this.resizeObserver.observe(step));
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onViewportChange, true);
      window.removeEventListener('resize', this.onViewportChange);
      this.motionQuery?.removeEventListener?.('change', this.onMotionChange);
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    }

    clamp(value, min = 0, max = 1) {
      return Math.min(max, Math.max(min, value));
    }

    update() {
      if (!this.steps.length || !this.dots.length) return;

      const hostRect = this.getBoundingClientRect();
      const dotRects = this.dots.map((dot) => dot.getBoundingClientRect());
      const firstDotRect = dotRects[0];
      const lastDotRect = dotRects[dotRects.length - 1];
      const firstDotY = firstDotRect.top + firstDotRect.height / 2;
      const lastDotY = lastDotRect.top + lastDotRect.height / 2;
      const lineTop = firstDotY - hostRect.top;
      const lineHeight = Math.max(0, lastDotY - firstDotY);
      const triggerRatio = Number.parseFloat(this.dataset.trigger || '0.64');
      const triggerY = window.innerHeight * this.clamp(triggerRatio, 0.35, 0.82);

      this.style.setProperty('--line-top', `${lineTop.toFixed(1)}px`);
      this.style.setProperty('--line-height', `${lineHeight.toFixed(1)}px`);

      if (this.motionQuery.matches) {
        this.style.setProperty('--line-progress', '1');
        this.steps.forEach((step) => {
          step.classList.add('is-active');
        });
        return;
      }

      const progress = lineHeight > 0 ? this.clamp((triggerY - firstDotY) / lineHeight) : 0;
      this.style.setProperty('--line-progress', progress.toFixed(4));

      this.steps.forEach((step, index) => {
        const dot = this.dots[index];
        if (!dot) return;

        const dotRect = dotRects[index];
        const dotCenter = dotRect.top + dotRect.height / 2;

        step.classList.toggle('is-active', dotCenter <= triggerY);
      });
    }
  }

  if (!customElements.get('abris-steps-flow')) {
    customElements.define('abris-steps-flow', AbrisStepsFlow);
  }

  class AbrisSnowAtmosphere extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.classList.add('is-paused');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.observer = new IntersectionObserver(
        ([entry]) => this.classList.toggle('is-paused', !entry.isIntersecting),
        { rootMargin: '100px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  }

  if (!customElements.get('abris-snow-atmosphere')) {
    customElements.define('abris-snow-atmosphere', AbrisSnowAtmosphere);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let lastWidth = window.innerWidth;

    const updateLockedHeroHeights = (force = false) => {
      const currentWidth = window.innerWidth;

      if (!force && Math.abs(currentWidth - lastWidth) < 40) return;

      lastWidth = currentWidth;

      document.querySelectorAll('[data-lock-mobile-viewport="true"]').forEach((hero) => {
        if (mobileQuery.matches) {
          hero.style.setProperty('--hero-locked-mobile-height', `${window.innerHeight}px`);
        } else {
          hero.style.removeProperty('--hero-locked-mobile-height');
        }
      });
    };

    const initializeLockedHeroHeights = () => {
      lastWidth = window.innerWidth;
      updateLockedHeroHeights(true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeLockedHeroHeights, { once: true });
    } else {
      initializeLockedHeroHeights();
    }

    window.addEventListener('resize', () => updateLockedHeroHeights(false), { passive: true });
    window.addEventListener('orientationchange', () => {
      requestAnimationFrame(() => updateLockedHeroHeights(true));
    });
    document.addEventListener('shopify:section:load', () => updateLockedHeroHeights(true));

    const scheduleMobileButtonFit = () => {
      if (window.abrisHeroMobileFitFrame) cancelAnimationFrame(window.abrisHeroMobileFitFrame);
      window.abrisHeroMobileFitFrame = requestAnimationFrame(() => {
        window.abrisHeroMobileFitFrame = 0;
        document.querySelectorAll('.hero[id$="hero_x9cT9L"] .hero__content-wrapper > .group-block > .group-block-content.layout-panel-flex--row').forEach((row) => {
          const links = [...row.children];
          if (
            links.length !== 2 ||
            !links.every((link) => link.matches('a.size-style')) ||
            !links.some((link) => link.classList.contains('button-custom'))
          ) return;

          links.forEach((link) => {
            link.style.removeProperty('font-size');
            if (!mobileQuery.matches) return;

            let fontSize = Math.min(14, Math.max(11, window.innerWidth * 0.033));
            let attempts = 0;

            while (
              link.scrollWidth > link.clientWidth + 1 &&
              fontSize > 7 &&
              attempts < 24
            ) {
              fontSize = Math.max(7, fontSize - 0.5);
              link.style.setProperty('font-size', `${fontSize}px`, 'important');
              attempts++;
            }
          });
        });
      });
    };

    window.addEventListener('resize', scheduleMobileButtonFit, { passive: true });
    window.addEventListener('orientationchange', scheduleMobileButtonFit);
    document.addEventListener('shopify:section:load', scheduleMobileButtonFit);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleMobileButtonFit, { once: true });
    } else {
      scheduleMobileButtonFit();
    }
    document.fonts?.ready.then(scheduleMobileButtonFit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
